<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li><span><a href="/sirang/miinteressa">IO SONO</a></span></li>
            <li class="last"><span><a href="/sirang/acque">OPERATORE</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-2" id="main-content" role="main">
         <div class="portlet-layout" id="aui_3_4_0_1_591">
            <div class="aui-w70 portlet-column" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_H7pGyMq5rlnM_">
                     <span id="p_56_INSTANCE_H7pGyMq5rlnM"></span> 
                     <div class="portlet-body" id="aui_3_4_0_1_590">
                        <section class="portlet" id="portlet_56_INSTANCE_H7pGyMq5rlnM">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Operatore</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content" id="aui_3_4_0_1_589">
                              <div class=" portlet-content-container" style="" id="aui_3_4_0_1_588">
                                 <div class="portlet-body" id="aui_3_4_0_1_587">
                                    <div class="journal-content-article" id="aui_3_4_0_1_586">
                                       <p>
                                          Nel SIRA gli Operatori, che accedono al sistema attraverso SPID o tessera sanitaria CNS sono di seguito descritti, sono generalmente soggetti appartenenti a enti pubblici che devono operare in back office nella verifica e istruttoria delle istanze presentate.
                                       </p>
                                       <p>
                                          Attraverso il modulo GPA (Gestore dei procedimenti amministrativi) l'operatore può visualizzare sulla propria scrivania la domanda pervenuta, la documentazione allegata e svolgere tutte le attività a suo carico previste dall'iter del procedimento, dalla gestione delle fasi di condivisione tra Enti, alle comunicazioni verso il richiedente, fino alla produzione dell'atto finale, se previsto.
                                       </p>
                                       <p>
                                          Accedendo al SIRA, attraverso i suoi moduli, l'operatore accede alla «comune base di conoscenza ambientale regionale» che riunisce e coordina le informazioni prodotte, in modo autonomo dalle diverse fonti dati di rilevanza ambientale
                                       </p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
            <div class="aui-w30 portlet-column" id="column-2">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-last" id="layout-column_column-2">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_RxuFFVEU5ofT_">
                     <span id="p_56_INSTANCE_RxuFFVEU5ofT"></span> 
                     <div class="portlet-body">
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>